import axios from "axios";
import appConfig from "../config/env";

class HttpClient {
  constructor() {
    this.axiosClient = axios.create({
      baseURL: appConfig.getBaseUrl(),
    });
  }

  async get(url, headers) {
    try {
      const res = await this.axiosClient.get(url, { headers });
      return { value: res.data, success: true };
    } catch (error) {
      return this.handleAxiosError(error);
    }
  }

  async post(url, data, headers) {
    try {
      const res = await this.axiosClient.post(url, data, { headers });
      if (res.status >= 200 && res.status <= 299) {
        return { success: true, value: res.data };
      } else {
        const data = res.data || { code: res.status, message: res.statusText };
        return { success: false, error: data };
      }
    } catch (error) {
      return this.handleAxiosError(error);
    }
  }

  async put(url, requestData, headers) {
    try {
      const res = await this.axiosClient.put(url, requestData, { headers });
      if (res.status >= 200 && res.status <= 299) {
        return { success: true, value: res.data };
      } else {
        const data = res.data || { code: res.status, message: res.statusText };
        return { success: false, error: data };
      }
    } catch (error) {
      return this.handleAxiosError(error);
    }
  }

  async patch(url, data, headers) {
    try {
      const res = await this.axiosClient.patch(url, data, { headers });
      if (res.status >= 200 && res.status <= 299) {
        return { success: true, value: res.data };
      } else {
        const data = res.data || { code: res.status, message: res.statusText };
        return { success: false, error: data };
      }
    } catch (error) {
      return this.handleAxiosError(error);
    }
  }

  async delete(url, headers) {
    try {
      const res = await this.axiosClient.delete(url, { headers });
      if (res.status >= 200 && res.status <= 299) {
        return { success: true, value: res.data };
      } else {
        const data = res.data || { code: res.status, message: res.statusText };
        return { success: false, error: data };
      }
    } catch (error) {
      return this.handleAxiosError(error);
    }
  }

  handleAxiosError(error) {
    const data = { code: 1500, message: `unknown` };
    if (!error.response) {
      data.code = 1408;
      data.message = `CORS request did not succeed`;
    } else if (error.response) {
      const res = error.response;
      if (res.data) {
        data.code = res.data.code || res.data.status;
        data.message = res.data.message || res.data.error;
      } else {
        data.code = error.response.status;
        data.message = error.response.statusText;
      }
    } else if (error.request) {
      data.code = 1500;
      data.message = `No response from server`;
    } else {
      data.code = 1408;
      data.message = `Request Timeout`;
    }
    return { success: false, error: data };
  }
}

const httpClient = new HttpClient();
export default httpClient;
